import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["funnelFields"]

  connect() {
    this.#toggleFunnelFields()
  }

  triggerChanged() {
    this.#toggleFunnelFields()
  }

  #triggerSelect() {
    return this.element.querySelector("[data-trigger-select]")
  }

  #toggleFunnelFields() {
    const isFunnel = this.#triggerSelect()?.value === "customer_in_funnel_step"
    this.funnelFieldsTarget.classList.toggle("d-none", !isFunnel)

    this.funnelFieldsTarget.querySelectorAll("input, select").forEach(el => {
      el.disabled = !isFunnel
    })
  }
}
